import { Record, Map } from 'immutable';

const ActivityTypeRecord = Record({
  id: undefined,
  name: undefined,
  hasDuration: undefined,
  hasDistance: undefined,
  hasReps: undefined,
  hasWeight: undefined,
  hasSets: undefined,
  _links: new Map(),
  _forms: new Map()
});

class ActivityType extends ActivityTypeRecord {

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default ActivityType;


// WEBPACK FOOTER //
// ./src/api/models/activityType.js